import { Component } from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";

export class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("[LUIZ.DEV] Erro de interface:", error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div data-testid="error-boundary" className="flex min-h-screen items-center justify-center bg-[#050505] px-4 text-zinc-100">
        <div className="w-full max-w-md rounded-2xl border border-[#22222A] bg-[#101014] p-8 text-center shadow-[0_24px_80px_rgba(0,0,0,0.6)]">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#E50914]/10">
            <AlertTriangle className="h-7 w-7 text-[#E50914]" />
          </div>
          <h1 className="mt-6 font-display text-2xl font-bold">Algo saiu do roteiro</h1>
          <p className="mt-3 text-sm leading-relaxed text-zinc-400">
            Ocorreu um erro inesperado nesta tela. Nada foi perdido — recarregue para continuar.
          </p>
          <button
            data-testid="error-boundary-reload"
            onClick={() => window.location.reload()}
            className="btn-red-glow mt-8 inline-flex items-center gap-2 rounded-full bg-[#E50914] px-7 py-3.5 font-mono-code text-xs font-bold uppercase tracking-widest text-white"
          >
            <RotateCcw className="h-4 w-4" />
            Recarregar
          </button>
        </div>
      </div>
    );
  }
}
